import * as actionTypes from '../../constants/actionTypes';

const defaultState = {
    isLoading: [],
    playersLoading: false,
    results: [],
    errorMessage: null,
    activeSport: null,
    sports: {}
};

export default function reducer(state = defaultState, action) {
    const sportName = action.sportName;
    let isLoading = null;

    switch (action.type) {
        case actionTypes.PROPS_ACTIVE_SPORT_CHANGED:
            return Object.assign({}, state, {
                activeSport: action.activeSport
            });

        case actionTypes.PROPS_FETCHING:
            isLoading = [...state.isLoading];

            if (!isLoading.includes(sportName)) {
                isLoading.push(sportName);
            }

            return Object.assign({}, state, {
                isLoading: isLoading,
                playersLoading: true,
                errorMessage: null
            });

        case actionTypes.PROPS_SUCCESS:
            isLoading = removeEntryFromArray(sportName, state.isLoading);
            const sports = { ...state.sports };
            sports[sportName] = action.playerProps;
            return Object.assign({}, state, {
                isLoading: isLoading,
                playersLoading: false,
                errorMessage: null,
                sports: [...sports],
                results: [...action.playerProps]
            });

        case actionTypes.PROPS_FAILED:
            isLoading = removeEntryFromArray(sportName, state.isLoading);

            return Object.assign({}, state, {
                isLoading: isLoading,
                playersLoading: false,
                errorMessage: action.errorMessage
            });
        default:
            return state;
    }
}

// function sortPropsByQuality(props) {
//     props.sort(function(p1, p2) {
//         if (p1.bet_quality !== undefined && p2.bet_quality !== undefined) {
//             const p1q = p1.bet_quality;
//             const p2q = p2.bet_quality;
//             if (p1q === p2q) {
//                 if (p1.player_name && p2.player_name) {
//                     const p1n = p1.player_name.toLowerCase();
//                     const p2n = p2.player_name.toLowerCase();
//                     return p1n < p2n ? -1 : p1n > p2n ? 1 : 0;
//                 }
//                 return 0;
//             } else if (p1q > p2q) {
//                 return -1;
//             }
//             return 1;
//         }
//         return p1;
//     });
//
//     return props;
// }

function removeEntryFromArray(itemToRemove, fromArray) {
    const result = [];
    for (const item of fromArray) {
        if (item !== itemToRemove) {
            result.push(item);
        }
    }
    return result;
}



// WEBPACK FOOTER //
// ./src/redux/reducers/props.js